<template>
    <div class="oblique">
        <div
            class="obliqueTags"
            v-for="(item, index) in tags"
            :key="index"
            @click="handleClick(item.value)"
            :style="{zIndex:item.value == currentName?tags.length+1:tags.length-index,}">
            <div class="obliqueTags_item" :class="{'active': item.value == currentName}">
                {{item.label}}{{item.num ? `(${item.num})`:''}}
            </div>
            <div class="obliqueTags_line" :class="{'active': item.value == currentName}"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'obliqueTags',
    props:{
      tags: Array,
      value: String
    },
    data() {
        return {
            currentName: this.value
        }
    },
    watch: {
        value(value) {
            this.setCurrentName(value);
        },
    },
    methods:{
        setCurrentName(value) {
            this.currentName = value
            this.$emit('input', value);
        },
        handleClick(value) {
            this.$emit('input', value);
            this.$emit('tab-click', value);
            this.setCurrentName(value)
        }
    }
}
</script>
<style lang="scss" scoped>
.oblique{
    width: 100%;
    display: flex;
    position: relative;
    margin-left: 8px;
}
.obliqueTags {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: -8px;
    .obliqueTags_item{
        line-height: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        border: 1px solid #d7d7d7;
        border-right: none;
        padding: 0 10px 0 20px;
        &.active{
            background-color: #ffffff;
            color: #409EFF;
            font-weight: 600;
        }
    }
    .obliqueTags_line{
        width: 20px;
        height: 30px;
        /*background-image: url("../../../assets/img/wrokOrder_hover.png");*/
        background-image: url("../../../assets/img/wrokOrder_s.png");
        background-repeat: no-repeat;
        background-position: right 0;
        background-size: contain;
        border-bottom: 1px solid #d7d7d7;
        &.active{
            background-image: url("../../../assets/img/wrokOrder_hover_white.png") !important;
        }
    }
}
</style>
